export var DocumentSubType;
(function (DocumentSubType) {
    DocumentSubType["APPL"] = "APPL";
    DocumentSubType["BINDINGOFFER"] = "BINDINGOFFER";
})(DocumentSubType || (DocumentSubType = {}));
